/** Shared motion tokens for homepage entrance animations. */

export const MOTION_EASE = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';

export const MOTION_DURATION = {
  header: 300,
  fadeUp: 450,
  zoomOut: 900,
  imageReveal: 700,
  maskReveal: 500,
  textFade: 550,
} as const;

export const MOTION_DISTANCE = {
  desktop: 24,
  mobile: 16,
  block: 20,
  blockMobile: 14,
} as const;

export const MOTION_STAGGER = {
  desktop: 100,
  mobile: 60,
} as const;

/** Matches project tablet breakpoint used across homepage components. */
export const MOTION_MOBILE_BREAKPOINT = 768;

export const IN_VIEW_DEFAULT = {
  rootMargin: '0px 0px -10% 0px',
  threshold: 0.15,
} as const;
